import React, { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Botão magnético — atrai o mouse ao passar (efeito premium sem parecer AI slop).
 * Também expõe --mx/--my pra .btn-magnetic pintar um radial gradient no hover.
 * Em touch/prefers-reduced-motion, comporta como botão simples.
 */
export default function MagneticButton({
  children,
  as: Tag = "button",
  className = "btn-magnetic",
  strength = 0.28,
  testid,
  ...rest
}) {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  const onMove = (e) => {
    if (reduced) return;
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    el.style.setProperty("--mx", `${(x / rect.width) * 100}%`);
    el.style.setProperty("--my", `${(y / rect.height) * 100}%`);
    const dx = (x - rect.width / 2) * strength;
    const dy = (y - rect.height / 2) * strength;
    el.style.transform = `translate(${dx}px, ${dy}px)`;
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "translate(0,0)";
  };

  return (
    <Tag
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={className}
      data-testid={testid}
      {...rest}
    >
      {children}
    </Tag>
  );
}
